@let active = activeJob$ | async;
@let ready = readyJob$ | async;

@if (active) {
    <span class="dmv-chip dmv-chip--running">
        <mat-icon class="dmv-chip-icon">autorenew</mat-icon>
        Algorithmic DMV running…
    </span>
} @else if (ready) {
    <button class="dmv-chip dmv-chip--ready" type="button"
            (click)="openReview(ready.taskInfoId)">
        <mat-icon class="dmv-chip-icon">task_alt</mat-icon>
        Algorithmic DMV ready ({{ ready.pendingReviewCount }} pending) — Review
    </button>
}
